import React from "react";
import { Trans } from "react-i18next";
import { Link } from "@material-ui/core";
import theme from "../../common/theme";

type LinkedMessageProps = {
  i18nKey: string;
  to: string;
  testId: string;
  gtmEvent?: string;
  target?: string;
  rel?: string;
  linkColor?: string;
};

const LinkedMessage: React.FC<LinkedMessageProps> = (props) => {
  return (
    <Trans i18nKey={props.i18nKey}>
      {""}
      <Link
        data-testid={props.testId}
        href={props.to}
        style={{
          textDecoration: "underline",
          fontWeight: theme.typography.fontWeightBold,
          color: props.linkColor ? props.linkColor : theme.palette.common.black,
        }}
        target={props.target || ""}
      >
        {""}
      </Link>
      {""}
    </Trans>
  );
};

export default LinkedMessage;
